export default __webpack_public_path__ + "static/hololens_1-43695ea15f3d788ea0edddabf3f219fb.png";